import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

const FAQSection = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  if (!faqs || faqs.length === 0) return null;

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-8" data-testid="faq-section">
      <div className="flex items-center gap-2 mb-6">
        <HelpCircle className="h-5 w-5 text-[#115E59]" />
        <h2 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'var(--font-heading)' }}>
          Frequently Asked Questions
        </h2>
      </div>

      <div className="space-y-0 divide-y divide-slate-100">
        {faqs.map((faq, i) => (
          <div key={i} className="py-4">
            <button
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              className="w-full flex items-start justify-between gap-4 text-left group"
              data-testid={`faq-item-${i}`}
            >
              <span className="text-sm font-semibold text-slate-800 group-hover:text-[#115E59] transition-colors leading-relaxed">
                {faq.question}
              </span>
              <ChevronDown className={`h-4 w-4 text-slate-400 flex-shrink-0 mt-1 transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`} />
            </button>
            {openIndex === i && (
              <div className="mt-3 text-sm text-slate-600 leading-relaxed animate-fade-in" style={{ animationDuration: '0.2s' }}>
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
